/* @flow */
import * as React from 'react'
import styled from 'styled-components'
import { unreadIndicator } from '../EmailUtils'
import UTM from '../../../utils/UTM'
import Headline from '../../../utils/Headline'
import HeadlineUnreadIndicator from './StyledHeadlineUnreadIndicator'
import HiddenCol from './StyledHiddenCol'
import Link from './StyledLink'
import Submit from './StyledSubmit'
import TextBox from './StyledTextBox'
import MojeidLink from './StyledMojeidLink'
import Loader from '../../../utils/Loader'
import { BottomCol, ButtonCol, Form, FormRow, FormCol } from './StyledContainers'
import { RememberFormGroup, RememberCheckbox, RememberLabel } from './StyledRememberCheckbox'
import type { InboxType, WidgetType } from '../Types'

const REMEMBER_ID = 'ego_expires'
const REMEMBER_VALUE = '1209600'

const HeadlineWrapper = styled.div`
  height: 24px;
  margin-bottom: 10px;
  position: relative;
`

type Props = {|
  inbox: InboxType,
  widget: WidgetType,
  loading: boolean
|}

export default (props: Props) => {
  const {
    inbox: {
      summary: {
        unread = 0
      } = {},
      summary = {}
    } = {},
    loading,
    widget,
    widget: {
      meta: {
        form,
        registration,
        mojeId
      },
      utmContent,
      utmMedium,
      utmSource
    }
  } = props
  const registrationLink = new UTM(registration.location).getUTMLink({utmMedium, utmSource, utmContent, utmTerm: 'registrovat'})

  return (
    <React.Fragment>
      <HeadlineWrapper>
        <Headline widget={widget}>
          {
            (Object.keys(summary).length > 0) &&
            <HeadlineUnreadIndicator className={unread === 0 ? 'grey' : ''}>
              { unreadIndicator(unread) }
            </HeadlineUnreadIndicator>
          }
        </Headline>
      </HeadlineWrapper>
      <Form action={form.action} method='POST'>
        { loading && <Loader/> }
        <FormRow>
          <FormCol>
            <TextBox type='text' name='ego_user' placeholder='Jméno'/>
          </FormCol>
          <FormCol>
            <TextBox type='password' name='ego_secret' placeholder='Heslo'/>
          </FormCol>
          <ButtonCol>
            <Submit type='submit'>
              Přihlásit
            </Submit>
          </ButtonCol>
        </FormRow>
        <FormRow>
          { mojeId &&
            <MojeidLink href={
              new UTM(mojeId.action).getUTMLink({utmMedium, utmSource})
            }>Přihlásit se do e-mailu přes mojeID</MojeidLink>
          }
        </FormRow>
        <FormRow>
          <BottomCol>
            <RememberFormGroup>
              <RememberCheckbox type='checkbox' id={REMEMBER_ID} name={REMEMBER_ID} value={REMEMBER_VALUE}/>
              <RememberLabel for={REMEMBER_ID}>
                zůstat přihlášen(a)
              </RememberLabel>
            </RememberFormGroup>
          </BottomCol>
          <BottomCol>
            <Link href={registrationLink}>
              { registration.text }
            </Link>
          </BottomCol>
          <HiddenCol/>
        </FormRow>
      </Form>
    </React.Fragment>
  )
}
